var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"notification-link mt-2",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("\n    "+_vm._s(_vm.$t('general.clickToEdit', {entity: this.entity}))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }